import styled from "styled-components"

import {ExpanderArrow} from "../Expander"
import {Label} from "../Typography"

export const StyledExpanderIcon = styled(ExpanderArrow)`
  fill: ${({theme}) => theme.colors.perkbox.blue};
  width: 14px;
  height: 14px;
`

export const HeaderLabel = styled(Label)`
  font-size: 14px;
  color: ${({theme}) => theme.colors.perkbox.blue};
`
